import { render, staticRenderFns } from "./fifthLogoRow.vue?vue&type=template&id=28393b75&"
import script from "./fifthLogoRow.vue?vue&type=script&lang=js&"
export * from "./fifthLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports